import styled from 'styled-components'
import IconButton from './IconButton'

const DeleteIconButton = styled(IconButton).attrs({
  type: 'circle-minus',
})``

export default DeleteIconButton
